import { FeatureFlag, FeatureFlagInterface } from '../constants';
import { useAppContext } from '../../AppContext';

interface UseFeatureFlagInterface {
  isFeatureFlagEnabled: (name: FeatureFlag) => boolean | undefined;
  updateFeatureFlag: (name: FeatureFlag, enabled: boolean) => void;
  featureFlags: FeatureFlagInterface[];
}
export function useFeatureFlags(): UseFeatureFlagInterface {
  const { setFeatureFlags, featureFlags } = useAppContext();

  const updateFeatureFlag = (name: FeatureFlag, enabled: boolean): void => {
    setFeatureFlags(
      featureFlags.map(featureFlag => {
        if (featureFlag.name === name) {
          return { ...featureFlag, enabled };
        }
        return featureFlag;
      })
    );
  };

  const isFeatureFlagEnabled = (name: FeatureFlag): boolean | undefined => {
    return featureFlags.find(featureFlag => featureFlag.name === name)?.enabled;
  };

  return {
    featureFlags,
    updateFeatureFlag,
    isFeatureFlagEnabled
  };
}
